import { SELLER_DATA, STORE_OPEN_STATUS } from '../seller'

export const expirationTime1h = 60 * 60 * 1000

export const deleteCookie = name => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export const getCookie = name => {
  let result
  const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)
  if (match) {
    result = match[2]
  }
  return result
}

export const saveCookie = (name, value, exp, isSecure = false) => {
  let expires
  const secure = isSecure ? 'secure' : ''
  const date = new Date()
  const expVal = exp || 7 * 24 * 60 * 60 * 1000 // Expires in 7 days

  if (getCookie(name)) {
    deleteCookie(name)
  }

  date.setTime(date.getTime() + expVal)
  expires = `expires=${date.toUTCString()}`

  document.cookie = `${name}=${value};Path=/;${expires};${secure}`
}

export const clearCookies = () => {
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  }
}

export const clearSellerData = () => {
  localStorage.removeItem(SELLER_DATA)
  localStorage.removeItem(STORE_OPEN_STATUS)
}
